import React from "react"
import classNames from "classnames"

import { ICheckListViewActions, IQuestion } from "../.."

import Question from "./Question"

export interface Props {
    containerElement: string
    contextMenuActions: ICheckListViewActions
    hasIndentation: boolean
    questions: IQuestion[] | null
}

export const QuestionList = ({
    containerElement,
    contextMenuActions,
    questions,
    hasIndentation,
}: Props): JSX.Element => {
    const classes = classNames("tw-flex tw-flex-col tw-gap-2", {
        "tw-pt-2": hasIndentation,
        "tw-pl-4": hasIndentation,
    })

    return (
        <div
            data-ft-component={containerElement}
            data-ft-count={questions?.length ?? 0}
            className={classes}
        >
            {!!questions && questions.length > 0 && (
                <>
                    {questions.map((question) => (
                        <Question
                            key={question.id}
                            contextMenuActions={contextMenuActions}
                            {...question}
                        />
                    ))}
                </>
            )}
        </div>
    )
}

export default QuestionList
